module.exports = __webpack_public_path__ + "f918e06219946e52a86bb9ede5b6c0b7.pdf";